import { render, staticRenderFns } from "./StoryDeleteModal.vue?vue&type=template&id=1aa3d25a&scoped=true"
import script from "./StoryDeleteModal.vue?vue&type=script&lang=js"
export * from "./StoryDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./StoryDeleteModal.vue?vue&type=style&index=0&id=1aa3d25a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa3d25a",
  null
  
)

export default component.exports